import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import { AsyncResult, DataServiceQuery, IContext, IDataServiceRequest, callActionOrExecute } from '@msdyn365-commerce/retail-proxy';

export function createAddCountingListLinesInput(productListId: string, countingListLines: Entities.ProductListLine[]): IDataServiceRequest {
    const query = new DataServiceQuery('DlvryProductLists', 'DlvryProductList');
    return query.createDataServiceRequestForOperation(
        'AddCountingListLines',
        true,
        EntityClasses.ProductListLineClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.ProductListLine' },
        { productListId, countingListLines }
    );
}

export function addCountingListLinesAsync(
    context: IContext,
    productListId: string,
    countingListLines: Entities.ProductListLine[]
): AsyncResult<Entities.ProductListLine[]> {
    const request = createAddCountingListLinesInput(productListId, countingListLines);
    return callActionOrExecute<Entities.ProductListLine[]>(request, context.callerContext);
}
